import { Injectable } from '@angular/core';
import { ModuleRecordFeedMappableEntityDto } from '../../Models/FeedConfigurationModels/ModuleRecordFeedMappableEntityDto';
import { IFeedConfigurationDataField } from '@app/Tenant/Applications/Airsweb/Services';
import { FeedModuleRecordMapperService } from '@app/Tenant/Applications/Airsweb/Feeds/feed-auto-mapper/feed-module-record-mapper.service';
import { LocationAttribute } from '@app/Tenant/Applications/Airsweb/Models/location-attribute.model';
import { FeedHierarchyMapperService } from '@app/Tenant/Applications/Airsweb/Feeds/feed-auto-mapper/feed-hierarchy-mapper.service';

@Injectable({
	providedIn: 'root',
})
export class FeedAutoMapperService {
  constructor(
    private feedModuleRecordMapperService: FeedModuleRecordMapperService,
    private feedHierarchyMapperService: FeedHierarchyMapperService
  ) {}

    autoMapModuleRecordFields(dataFields: IFeedConfigurationDataField[], mappableEntities: ModuleRecordFeedMappableEntityDto[], overwritePreviousMappings: boolean) {
        if (!mappableEntities || mappableEntities.length === 0) {
            return;
        }

        for (const dataField of dataFields) {
            if (!overwritePreviousMappings && dataField.ModelPropertyName) {
                continue;
            }

			const mappableEntity = this.feedModuleRecordMapperService.findMappableEntityForDataField(
				dataField,
				mappableEntities
			);
            if (!mappableEntity) {
                continue;
            }

            dataField.DataType = mappableEntity.FieldUniqueId;
            dataField.RecordPropertyName = mappableEntity.FieldId;
            dataField.ListType = mappableEntity.ListType;
            dataField.ListKey = mappableEntity.ListKey;
            dataField.Path = mappableEntity.Path;
            dataField.ModelPropertyName = mappableEntity.ModelPropertyName;
            dataField.LinkedRecordModuleId = mappableEntity.LinkedRecordModuleId;
            dataField.IsNaturalKey = dataField.IsNaturalKey || this.isNaturalKeyProperty(mappableEntity.ModelPropertyName);
        }
    }


    autoMapHierarchyFields(
        dataFields: IFeedConfigurationDataField[], 
        hierarchyAttributes: LocationAttribute[], 
        overwritePreviousMappings: boolean, 
        selectedAttributes: LocationAttribute[]): void {
        for (const dataField of dataFields) {
            const dataFieldName = dataField.Name;
            if (!overwritePreviousMappings && dataField.LocationLevel && (dataField.ListKey || dataField.AttributeId)) {
                continue;
            }

            this.feedHierarchyMapperService.mapToBestHierarchyFieldOrAttribute(
                dataFieldName,
                dataField,
                hierarchyAttributes,
                selectedAttributes
            );
        }
    }

    isNaturalKeyProperty(modelPropertyName: string): boolean {
      if (!modelPropertyName) {
        return false;
      }
      if (modelPropertyName === 'ImportedSystemId' ||
          modelPropertyName === 'ExternalId' ||
          modelPropertyName.endsWith('SystemId')) {
          return true;
      }
      return false;
    }
}


